module.exports = __webpack_public_path__ + "static/media/ios_download.bb9b4ac2.png";